module.exports = __webpack_public_path__ + "img/offer-template.ad6c1c55.png";